import React from "react";

var TSpan = function TSpan(props) {
  return React.createElement("tspan", props);
};

export default TSpan;